/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  
  $('.brand-main-gallery').owlCarousel({
    loop:true,
    margin:20,
    dots:false,
     autoplay:true,
    autoplayTimeout:3000,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        600:{
            items:3,
            nav:true
        },
        1000:{
            items:4,
            nav:true,
            loop:true
        }
    }
})
  
    
  $('.content-slider').owlCarousel({
    loop:true,
    margin:20,
    dots:false,
     autoplay:true,
    autoplayTimeout:4000,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:false
        },
        600:{
            items:1,
            nav:false
        },
        1000:{
            items:1,
            nav:false,
            loop:true
        }
    }
})
  
  
  
  
  $('.owl-carousel.img-gallery').owlCarousel({
    loop:true,
    margin:10,
    center: true,
    responsiveClass:true,
    responsive:{
      0:{
        items:1.8,
        nav:false,
        dots:true
      },
      600:{
        items:3,
        nav:false
      },
      1000:{
        items:5,
        nav:true,
        loop:false
      }
    }
  })
  


    jQuery('.gs-header').on('click',function(){
      if(jQuery(window).width()<=749){
        var act = jQuery(this).attr('aria-expanded');
        console.log('Expanded '+act);
        if(act == 'false'){
          jQuery(this).addClass('active');
          jQuery(this).next('.gs-content').slideDown();
          console.log('open');
          jQuery(this).attr('aria-expanded','true');
        }
        if(act == 'true'){
          jQuery(this).removeClass('active');
          jQuery(this).next('.gs-content').slideUp();
          console.log('close');
          jQuery(this).attr('aria-expanded','false');
        }
      }
    });



  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 1) {
      $(".clearHeader").addClass("darkHeader-cstm");
    } else {
        $(".clearHeader").removeClass("darkHeader-cstm");
    }
  });
  
  
  var acc = document.getElementsByClassName("accordion-c");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
  
  
  $('.owl-carousel.relut-img').owlCarousel({
    loop:true,
    margin:0,
    responsiveClass:true,
    nav:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:1
        },
        1000:{
            items:1
        }
    }
})


  $('.image_link-slider-home').owlCarousel({
    loop:true,
    margin:0,
    autoplayTimeout:5000,
    autoplay:true,
    responsiveClass:true,
    nav:true,
     dots:false,
    responsive:{
        0:{
            items:2
        },
        600:{
            items:2
        },
        1000:{
            items:1
        }
    }
})
  

  $('.image_link-slideshow').owlCarousel({
    loop:true,
    margin:0,
    autoplayTimeout:5000,
    autoplay:true,
    responsiveClass:true,
    nav:true,
    responsive:{
        0:{
            items:1
        },
       480:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
})
  

 setTimeout(function() {
  $('.complementary-products__slider').slick({ 
    infinite: false,
    fade: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [ 
      {
        breakpoint: 2000,
        settings: { 
          slidesToShow: 1
        }
      }
    ]
  });
}, 1000); // 2 second delay


 
  $('.featured_collection_slider').slick({ 
    infinite: false,
    fade: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [ 
      {
        breakpoint: 2000,
        settings: { 
          slidesToShow: 4
        }
      },
      {
        breakpoint: 1100,
        settings: { 
          slidesToShow: 3
        }
      },
      {
        breakpoint: 798,
        settings: { 
          slidesToShow: 2
        }
      },
      {
        breakpoint: 750,
        settings: { 
          slidesToShow: 1
        }
      }
    ]
  });
 




});

 


